export default "__VITE_ASSET__IGlooMny__"